import SchemaOrganization from "./SchemaOrganization";
import SchemaParentOrganization from "./SchemaParentOrganization";
import SchemaSameAsOrganization from "./SchemaSameAsOrganization";

export default SchemaOrganization;
export { SchemaParentOrganization, SchemaSameAsOrganization };
